import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    boxSizing: 'border-box',
    height: '100%',
    width: '100%',
    minHeight: 0,
    minWidth: 0,
    overflow: 'hidden',
    containerType: 'inline-size',
  },
  reportControls: {
    boxSizing: 'border-box',
    width: '100%',
    // Match the report's 1440px content width plus its responsive gutters.
    maxWidth: '1472px',
    flexShrink: 0,
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingLeft: tokens.spacingHorizontalL,
    paddingRight: tokens.spacingHorizontalL,
    '@container (max-width: 700px)': {
      paddingLeft: tokens.spacingHorizontalXS,
      paddingRight: tokens.spacingHorizontalXS,
    },
  },
  iframe: {
    flex: 1,
    border: 'none',
    width: '100%',
    minHeight: 0,
  },
  centered: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: tokens.spacingVerticalM,
    height: '100%',
    padding: tokens.spacingVerticalXXL,
  },
});
